import {web3} from './web3.js';
import Samples2D from './2D/2D.js';
import accounts from 'accounts/Accounts.js';
import Folders from './folders/Folders.js';
import Xanadu from './xanadu/Xanadu.js';
import Contract from 'decentralized/contracts/ethereumContract.js';
import EthereumTransaction from './transactions/EthereumTransaction.js';
import {GUILD_SAMPLES, FAVORITES} from './transactions/contracts.js';
import MultiSamplesContract from 'decentralized/contracts/MultiSamplesContract.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';
import TokenizedSequences from './TokenizedSequences.js';
import SlicesContract from 'decentralized/contracts/ethereumSlicesContract.js';
import Crypto from 'crypto/Crypto.js';
import Encryption from 'decentralized/Encryption.js';
import Messaging from 'decentralized/messaging/Messaging.js';
import FavoritesContract from 'decentralized/contracts/ethereumFavoritesContract.js';
import IndexContract from 'decentralized/contracts/ethereumIndexContract.js';
import SequencesContract from 'decentralized/contracts/SequencesContract.js';
import EthereumUsers from 'decentralized/ethereumUsers.js';
import Guilds from 'decentralized/guilds/Guilds.js';
import GuildSamples from 'decentralized/guilds/GuildSamples.js';
import GuildSequences from 'decentralized/guilds/GuildSequences.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EthereumQuery from 'decentralized/EthereumQuery.js';
import {NewDiscogsSample} from 'decentralized/EthereumEvents.js';
import {SampleTagged} from 'decentralized/EthereumEvents.js';
import {SampleStyle} from 'decentralized/EthereumEvents.js';
import {SampleYear} from 'decentralized/EthereumEvents.js';
import {SampleCountry} from 'decentralized/EthereumEvents.js';
import {SampleYoutube} from 'decentralized/EthereumEvents.js';
import {SequenceCreated} from 'decentralized/EthereumEvents.js';
import {SampleCreated} from 'decentralized/EthereumEvents.js';
import Presets2 from './presets/Presets2.js';
import DMCA from './dmca/DMCA.js';
import {SampleFavorited} from 'decentralized/EthereumEvents.js';
import {SampleUnfavorited} from 'decentralized/EthereumEvents.js';
import {SequenceEdited} from 'decentralized/EthereumEvents.js';
import Resample from 'decentralized/resample/Resample.js';

const contract = new GuildSamplesContract();
console.log('initialized contract wiht address = ' + contract.contractAddress);
const slicesContract = new SlicesContract();
const favoritesContract = new FavoritesContract();
const indexContract = new IndexContract();
const sequencesContract = new SequencesContract();
const multiSamplesContract = new MultiSamplesContract();

const bs58 = require('bs58');
const MIN_BLOCK = 3700000;
const ALL_SOUNDS_QUERY_LIMIT = 500;

class Ethereum {
    constructor() {
        if (web3  === undefined) {
            return;
        }
        this.web3 = web3;
        if (web3.eth.net.isListening()) {
            this.contract = new web3.eth.Contract(contract.abi, contract.contractAddress);
            this.slicesContract = new web3.eth.Contract(slicesContract.abi, slicesContract.contractAddress);
            this.favoritesContract = new web3.eth.Contract(favoritesContract.abi, favoritesContract.contractAddress);
            this.slicesContractAddress = this.slicesContract.options.address;
            this.ethAddress = this.contract.options.address;
            this.favoritesContractAddress = this.favoritesContract.options.address;
            this.sequencesContract = new web3.eth.Contract(sequencesContract.abi, sequencesContract.contractAddress);
            this.sequencesContractAddress = this.sequencesContract.options.address;

            this.indexContract = new web3.eth.Contract(indexContract.abi, indexContract.contractAddress);
            this.indexContractAddress = this.indexContract.options.address;
            this.multiSamplesContract = multiSamplesContract.getContract(web3);
        }

        this.cachedTags = undefined;
        this.users = new EthereumUsers(web3);
        this.crypto = new Crypto(this);
        this.encryption = new Encryption(web3, this.crypto);
        this.guilds = new Guilds(web3, this.crypto, this.encryption);
        this.tokenizedSequences = new TokenizedSequences(web3);
        this.guildSequences = new GuildSequences(web3, this.guilds, this.encryption, this.crypto);
        this.samples2D = new Samples2D(web3);
        this.messaging = new Messaging(web3);
        this.dmca = new DMCA(web3);
        this.folders = new Folders(web3);
        this.resample = new Resample(web3);
        this.presets = new Presets2(web3, this.crypto, this.guilds);
        this.xanadu = new Xanadu(web3);
        this.guildSamples = new GuildSamples(web3);
    }

    async postUserId() {
    }

    get guildId() {
        if (this.store === undefined) {
            return 0;
        }
        let guild = this.store.getState().guilds.selectedGuild;
        return guild ? guild.guildId : 0;
    }

    isMetamaskInstalled() {
        return false;
    }

    getUser() {
        return new Promise(async (resolve, reject) => {
            resolve(await accounts.getAccount());
        });
    }


    async getSoundsWithUserBlockNumber(user, blockNumber) {
        let query = new BackendQuery(this.ethAddress)
            .from(SampleCreated)
            .select('ipfsHash')
            .where('user', user)
            .fromBlock(blockNumber)
            .toBlock(blockNumber)
            .where('guildId', this.guildId);

        let results = await query.executeQuery(true);
        return Array.from(new Set(results.map(x => x.ipfsHash)));
    }
    async getSoundsWithDiscogs(discogsId) {
        let query = new BackendQuery(this.ethAddress)
            .from(NewDiscogsSample)
            .select('sampleHash')
            .where('discogsId', discogsId)
            .where('guildId', this.guildId)
        ;

        let results = await query.executeQuery(true);
        return Array.from(new Set(results.map(x => x.sampleHash)));
    }

    async getCoverArtForDiscogs(discogsId) {
        let query = new BackendQuery(this.ethAddress)
            .from(NewDiscogsSample)
            .select('coverArtHash')
            .where('discogsId', discogsId);

        let results = await query.executeQuery(true);
        return results[0];
    }

    getCachedTags(start, size) {
        if (start > this.cachedTags.length) {
            return [];
        }

        if (start + size > this.cachedTags.length) {
            return this.cachedTags.slice(start);
        }

        return this.cachedTags.slice(start, start + size);
    }

    searchTags(searchString) {
        return new Promise((resolve, reject) => {
            if (this.cachedTags === undefined) {
                // TODO: should fill the cache
                resolve([]);
                return;
            }
            
            searchString = searchString.toLowerCase();
            resolve(
                this.cachedTags
                    .filter(tag => tag.toLowerCase().includes(searchString)));
        });
    }

    async getTagsForSound(soundHash) {
        let tags = await new BackendQuery(this.ethAddress)
            .from(SampleTagged)
            .select('tag')
            .where('ipfsHash', soundHash)
            .executeQuery(true);

        return tags.map(t => t.tag);
    }

    async getYearsForSound(soundHash) {
        let year = await new BackendQuery(this.ethAddress)
            .from(SampleYear)
            .select('year')
            .where('ipfsHash', soundHash)
            .executeQuery(true);

        return year.map(t => t.year);
    }

    async getVideoIdForSound(soundHash) {
        let videoId = await new BackendQuery(this.ethAddress)
            .from(SampleYoutube)
            .select('videoId')
            .where('ipfsHash', soundHash)
            .executeQuery(true);

        return videoId.map(t => t.videoId)[0];
    }

    async getTitleForSound(soundHash) {
        let title = await new BackendQuery(this.ethAddress)
            .from(SampleCreated)
            .select('title')
            .where('ipfsHash', soundHash)
            .executeQuery(true);

        title = title
            .filter(t => t.title !== '')[0];

        return title !== undefined ? title.title : undefined;
   }

    async getUserNameForSound(soundHash) {
        let user = await new BackendQuery(this.ethAddress)
            .from(SampleCreated)
            .select('user')
            .where('ipfsHash', soundHash)
            .executeQuery(true);

        user = user.map(u => u.user)[0];
        if (user !== undefined) {
            // user  = web3.utils.padLeft(user, 64).toLowerCase();
            console.log('user = ' + user);
            return await this.users.getUserName(user);
        }
        return undefined;
   }

    async getCoverArtForSound(soundHash) {
        let coverArt = await new BackendQuery(this.ethAddress)
            .from(NewDiscogsSample)
            .select('coverArtHash')
            .where('sampleHash', soundHash)
            .executeQuery(true);

        coverArt = coverArt 
            .filter(t => t.coverArtHash !== '')[0];

        return coverArt !== undefined ? coverArt.coverArtHash : undefined;
   }

    getFavoritesForSound(soundHash) {
        return new Promise(async (resolve, reject) => {

            const account = await accounts.getAccount();
            if (account === undefined) {
                resolve({userFavorited: [], othersFavorited: []});
                return;
            }

            let favorites = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleFavorited)
                .select('user')
                .where('sampleHash', soundHash)
                .executeQuery();

            let unfavorites = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleUnfavorited)
                .select('user')
                .where('sampleHash', soundHash)
                .executeQuery();

            let userAccount = account.toLowerCase();
            let userFavorited = favorites.filter(result => result.user === userAccount);
            let otherUsersFavorited = favorites.filter(result => result.user !== userAccount);
            let userUnfavorited = unfavorites.filter(result => result.user === userAccount);
            let otherUsersUnfavorited = unfavorites.filter(result => result.user !== userAccount);
            resolve({
                userFavorited: userFavorited.length - userUnfavorited.length,
                othersFavorited: otherUsersFavorited.length - otherUsersUnfavorited.length
            });
        });
    }

    getOverallVotedRankings() {
        return new Promise(async (resolve, reject) => {
            let samplesFavorited = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleFavorited)
                .select('sampleHash')
                .executeQuery();

            let samplesUnfavorited = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleUnfavorited)
                .select('sampleHash')
                .executeQuery();

            let sampleToRanking = {};
            samplesFavorited.forEach(
                result => {
                    let sample = result.sampleHash;
                    if (sample in sampleToRanking) {
                        sampleToRanking[sample]++;
                    } else {
                        sampleToRanking[sample] = 1;
                    }
                });

            samplesUnfavorited.forEach(
                result => {
                    let sample = result.sampleHash;
                    if (sample in sampleToRanking) {
                        sampleToRanking[sample]--;
                    } else {
                        sampleToRanking[sample] = -1;
                    }
                });

            resolve(sampleToRanking);
        });
    }

    getFavoritesForUser() {
        return new Promise(async (resolve, reject) => {
            const account = await accounts.getAccount();
            if (account === undefined) {
                resolve([]);
                return;
            }
            let userAccount = account.toLowerCase();
            let favorites = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleFavorited)
                .select('sampleHash')
                .where('user', userAccount)
                .executeQuery();

            let unfavorites = await new BackendQuery(this.favoritesContractAddress)
                .from(SampleUnfavorited)
                .select('sampleHash')
                .where('user', userAccount)
                .executeQuery();

            let userFavorited = favorites.map(result => result.sampleHash);
            let userUnfavorited = unfavorites.map(result => result.sampleHash);

            let favoriteCount = {};
            let unfavoriteCount = {};
            for (let i in userFavorited) {
                if (userFavorited[i] in favoriteCount) {
                    favoriteCount[userFavorited[i]]++;
                } else {
                    favoriteCount[userFavorited[i]] = 1;
                }
            }

            for (let i in userUnfavorited) {
                if (userUnfavorited[i] in unfavoriteCount) {
                    unfavoriteCount[userUnfavorited[i]]++;
                } else {
                    unfavoriteCount[userUnfavorited[i]] = 1;
                }
            }

            let favoritedSounds = [];
            for (let i in favoriteCount) {
                let count = favoriteCount[i];
                if (i in unfavoriteCount) {
                    count -= unfavoriteCount[i];
                }

                if (count > 0) {
                    favoritedSounds.push(i);
                }
            }

            resolve(favoritedSounds);
        });
    }

    async getSoundsWithVideo(videoId) {
        let samples = await new BackendQuery(this.ethAddress)
            .from(SampleYoutube)
            .select('ipfsHash')
            .where('videoId', videoId)
            .where('guildId', this.guildId)
            .executeQuery();

        return Array.from(new Set(samples.map(s => s.ipfsHash)));
    }

    async getSoundsWithOrTags(tags) {
        let query = new BackendQuery(this.ethAddress)
            .from(SampleTagged)
            .select('ipfsHash')
            .whereIn('tag', tags)
            .whereIn('guildId', await this.getGuildsWithAccess());

        let results = await query.executeQuery();
        return results.map(s => s.ipfsHash);
    }

    async getSoundsWithTag(tag) {
        let toBlock = undefined;
        let fromBlock = undefined;

        if (this.cache.useMonth) {
            toBlock = this.cache.toBlock;
            fromBlock = this.cache.fromBlock;
        }
        return Array.from(new Set(await this.getSoundsWithField(
            'tag', tag, SampleTagged, 
            false, fromBlock, toBlock)));
    }

    async getSoundsWithStyle(style) {
        let toBlock = undefined;
        let fromBlock = undefined;

        if (this.cache.useMonth) {
            toBlock = this.cache.toBlock;
            fromBlock = this.cache.fromBlock;
        }
        return this.getSoundsWithField(
            'style',
            style,
            SampleStyle,
            false,
            fromBlock, toBlock);
    }

    async getSoundsWithCountry(country) {
        let toBlock = undefined;
        let fromBlock = undefined;

        if (this.cache.useMonth) {
            toBlock = this.cache.toBlock;
            fromBlock = this.cache.fromBlock;
        }
        return this.getSoundsWithField(
            'country',
            country,
            SampleCountry,
            false,
            fromBlock,
            toBlock);
    }

    async getSoundsWithYear(year) {
        let toBlock = undefined;
        let fromBlock = undefined;

        if (this.cache.useMonth) {
            toBlock = this.cache.toBlock;
            fromBlock = this.cache.fromBlock;
        }
        return this.getSoundsWithField(
            'year',
            year,
            SampleYear,
            false,
            fromBlock,
            toBlock);
    }

    async getSoundsWithFieldParallel(field, value, eventType, raw=false, fromBlock, toBlock) {
        if (fromBlock + 1 >= toBlock) {
            return [];
        }
        let x = 8;
        let diff = toBlock - fromBlock;
        let promises = [];
        for (let i=1; i <= x; i++) {
            let from = fromBlock + Math.floor((i-1) * diff / x);
            let to = fromBlock + Math.floor(i * diff / x);
            promises.push(this.getSoundsWithField(field, value, eventType, raw, from, to));
        }

        let results = await Promise.all(promises);

        let finalResults = [];
        for (let i in results) {
            finalResults = finalResults.concat(results[i]);
        }

        return Array.from(new Set(finalResults));
    }
    
    async getSoundsWithField(fieldName, value, eventType, raw=false, fromBlock=MIN_BLOCK, toBlock) {
        try {
            return await this.getSoundsWithFieldHelper(fieldName, value, eventType, raw, fromBlock, toBlock);
        } catch (err) {
            return await this.getSoundsWithFieldParallel(fieldName, value, eventType, raw, fromBlock, toBlock);
        }
    }

    async getGuildsWithAccess() {
        let dateA = new Date().getTime();
        if (this.guildId !== 0) {

            return [this.guildId];
        }
        let guilds = [... await this.guilds.getGuildsWithAccess()];
        guilds.sort();
        for (let i in guilds) {
            if (i >= 1) {
                // todo: allow more than 1 guild to be used here
                // really need to have a way of setting which guilds are
                // enabled by default
                break;
            }
            await this.guilds.getGuildKey(guilds[i]);
        }
        if (guilds.length > 0) {
            guilds = [guilds[0]];
        }
        let dateB = new Date().getTime();
        return [... guilds, 0];
    }

    getSoundsWithFieldHelper(field, value, eventType, raw=false, fromBlock=MIN_BLOCK, toBlock) {
        let fromBlockHex = undefined;
        if (fromBlock) {
            fromBlockHex = web3.utils.toHex(fromBlock);
        }

        let toBlockHex = undefined;
        if (toBlock) {
            toBlockHex = web3.utils.toHex(toBlock);
        }
        return new Promise(async (resolve, reject) => {
            let guilds = await this.getGuildsWithAccess();
            let query = new BackendQuery(this.ethAddress)
                .from(eventType)
                .select('ipfsHash')
                .where(field, value)
                .whereIn('guildId', guilds);

            if (toBlock) {
                query.toBlock(toBlock);
            }
            if (fromBlock) {
                query.fromBlock(fromBlock);
            }
                           

            let results = await query.executeQuery(true);
            resolve(results.map(x => x.ipfsHash));
        });
    }

    getSoundsFromBlock(blockNumberFrom, blockNumberTo) {
        return new Promise(async (resolve, reject) => {
            console.log('getting guilds with access');
            let a = new Date().getTime();
            let guildsWithAccess = await this.getGuildsWithAccess();
            let b = new Date().getTime();
            let time = b - a;
            console.log('getting guilds with access took %s ms', time);
            let query = new BackendQuery(this.ethAddress)
                .from(SampleCreated)
                .select('ipfsHash')
                .select('guildId')
                .fromBlock(blockNumberFrom)
                .toBlock(blockNumberTo)
                .limit(1000)
                .whereIn('guildId', window.installation ? [0] : guildsWithAccess);

            let results = await query.executeQuery(true);
            resolve(results.map(x => x.ipfsHash));
        });
    }

    async getBlockDate(blockNumber) {
        console.log('getting blockdate = ', blockNumber);
        let block = await web3.eth.getBlock(blockNumber);
        if (block === null) {
            return undefined;
        }
        return new Date(block.timestamp * 1000);
    }

    async getBlockNumberAtDate(date) {
        let blockNumber = await web3.eth.getBlockNumber();
        let blockPart = 500;

        let block = await web3.eth.getBlock(blockNumber);
        let currentDate = new Date(block.timestamp * 1000);

        while (date.getTime() < currentDate.getTime()) {
            blockNumber = blockNumber - blockPart;
            block = await web3.eth.getBlock(blockNumber);
            currentDate = new Date(block.timestamp * 1000);
        }

        return blockNumber;
    }

    async getAllSounds(fromDate, toDate) {
        // search by blocks until we've found enough sounds
        // we search *current block - blockPart* to *current block*
        let blockPart = 50000;

        let toBlock = undefined;
        let fromBlock = undefined;
        if (this.cache.useMonthly) {
            toBlock = this.cache.toBlock;
            fromBlock = this.cache.fromBlock;
        } else {
        }
        let results = [];

        let dateA = new Date();
        results = await this.getSoundsFromBlock(fromBlock, toBlock);
        let dateB = new Date();
        let time = dateB.getTime() - dateA.getTime();
        return results;
    }

    async getOldSequence(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.ethAddress)
                .select('user')
                .select('ipfsHash')
                .select('title')
                .where('ipfsHash', ipfsHash)
                .from(SequenceCreated);

            let sequences = await sequencesQuery.executeQuery();

            resolve(sequences.map(sequence => ({
                user: sequence.user,
                previousSequence: '0x0',
                newSequence: sequence.ipfsHash,
                diff: '0x0',
                title: sequence.title,
                blockNumber: sequence.blockNumber,
                edits: 0,
            })));
        });
    }

    async getPrivateSequences(fromBlock, toBlock) {
        const account = await accounts.getAccount();
        if (account === undefined) {
            return [];
        }
        return await this.encryption.getEncryptedSequenceIfAny(undefined, account, fromBlock, toBlock);
        // let sharedWith = await this.encryption.getSequencesSharedWithUser(undefined, fromBlock, toBlock);
        // return sequences === undefined ? [] : sequences.concat(sharedWith);
    }

    async getNewSequence(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.sequencesContractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('diff')
                .select('title')
                .where('newSequence', ipfsHash)
                .from(SequenceEdited);

            let sequences = await sequencesQuery.executeQuery();
            resolve(sequences.map(sequence => ({... sequence, edits: 0})));
        }); 
    }

    async getTokenizedSequence(ipfsHash) {
        return await this.tokenizedSequences.getSequence(ipfsHash);
    }

    async getSequence(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            let tokenizedSequence = await this.getTokenizedSequence(ipfsHash);
            if (tokenizedSequence.length > 0) {
                resolve(tokenizedSequence[0]);
                return;
            }

            let oldSequence = await this.getOldSequence(ipfsHash);
            if (oldSequence.length > 0) {
                resolve(oldSequence[0]);
                return;
            }
            let newSequence = await this.getNewSequence(ipfsHash);
            if (newSequence.length > 0) {
                resolve(newSequence[0]);
                return;
            }
            resolve("");
        });
    }

    favoriteSound(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            if (!accounts.isLoggedIn()) {
                resolve();
                return;
            }
            ipfsHash = ipfsHashToBytes32(ipfsHash);
            new EthereumTransaction(
                FAVORITES,
                'favoriteSample',
                [ipfsHash])
                .execute()
                .then((t) => resolve(t));
        });
    }

    unfavoriteSound(ipfsHash) {
        return new Promise(async (resolve, reject) => {
            if (!accounts.isLoggedIn()) {
                resolve();
                return;
            }
            ipfsHash = ipfsHashToBytes32(ipfsHash);
            new EthereumTransaction(
                FAVORITES,
                'unfavoriteSample',
                [ipfsHash])
                .execute()
                .then((t) => resolve(t));
        });
    }

    saveNewSequence(previousSequence, newSequence, title, samples) {
        return new Promise(async (resolve, reject) => {
            this.tokenizedSequences.saveNewSequence(
                previousSequence,
                newSequence,
                title,
                samples);
        });
    }

    getNewSequences(user, fromBlock, toBlock, includePrivate=true) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.sequencesContractAddress)
                .select('user')
                .select('previousSequence')
                .select('newSequence')
                .select('diff')
                .select('title')
                .fromBlock(fromBlock)
                .toBlock(toBlock)
                .from(SequenceEdited);

            if (user !== undefined) {
                sequencesQuery.where('user', user);
            }

            try {
                let sequences = await sequencesQuery.executeQuery();
                sequences.reverse();
                /*
                  if (includePrivate) {
                  let privateSequences = await this.getPrivateSequences(fromBlock, toBlock);
                  console.log('private sequences = ');
                  console.log(privateSequences);
                  sequences = sequences.concat(privateSequences);
                  }
                */
                sequences.sort((a,b) => b.blockNumber - a.blockNumber);
                resolve(sequences.map(sequence => ({... sequence, edits: 0})));
            } catch (e) {
                resolve([]);
            }
        }); 
    }

    getOldSequences(user, fromBlock, toBlock) {
        return new Promise(async (resolve, reject) => {
            let sequencesQuery = new BackendQuery(this.ethAddress)
                .select('user')
                .select('ipfsHash')
                .fromBlock(fromBlock)
                .toBlock(toBlock)
                .select('title')
                .from(SequenceCreated);

            if (user !== undefined) {
                sequencesQuery.where('user', user);
            }

            try {
                let sequences = await sequencesQuery.executeQuery();
                sequences.reverse();
                
                sequences = sequences.map(sequence => ({
                    user: sequence.user,
                    previousSequence: '0x0',
                    newSequence: sequence.ipfsHash,
                    diff: '0x0',
                    title: sequence.title,
                    blockNumber: sequence.blockNumber,
                    edits: 0,
                }));
                
                resolve(sequences);
            } catch (e) {
                resolve([]);
            }
        });
    }

    async getUser() {
        return await accounts.getAccount();
    }

    getSequences(user, fromBlock, toBlock) {
        return new Promise(async (resolve, reject) => {
            let tokenizedSequences = await this.tokenizedSequences.getSequences(user);
            let newSequences = await this.getNewSequences(user);
            let oldSequences = await this.getOldSequences(user);
            resolve(newSequences.concat(oldSequences));
        });
    }

    getHeadSequence(idToNext, id) {
        if (!(id in idToNext)) {
            return id;
        }

        return this.getHeadSequence(idToNext, idToNext[id]);
    }
    // makes sure to only show the head of each sequence
    collapseAllSequences(sequences) {
        let sequencesToSkip = new Set();
        let collapsedSequences = [];
        let idToNextSequence = {};
        sequences.forEach(sequence => {
            if (sequence.previousSequence !== '0x0' &&
                sequence.previousSequence !== sequence.newSequence) {
                sequencesToSkip.add(sequence.previousSequence);
                idToNextSequence[sequence.previousSequence] = sequence.newSequence;
            }
            if (!sequencesToSkip.has(sequence.newSequence)) {
                let edits = this.getEditsForSequence(sequence.newSequence, sequences);
                collapsedSequences.push({...sequence, edits: edits.length - 1});
            } else {
            }
        });
        return collapsedSequences;
    }

    getEditsForSequence(id, sequences) {

        let edits = [];

        let previousSequence = this.getPreviousSequence(id, sequences);
        while (previousSequence !== undefined) {
            edits.push(previousSequence);
            let nextPreviousSequence= this.getPreviousSequence(previousSequence.previousSequence, sequences);
            if (nextPreviousSequence === undefined || nextPreviousSequence.newSequence === previousSequence.newSequence) {
                break;
            }
            previousSequence = nextPreviousSequence;
        }

        return edits;
    }

    getPreviousSequence(id, sequences) {
        // warning: this may get slow the more sequences we have
        // since it needs to go through the whole list to succeed
        let previous = undefined;
        for (let i in sequences) {
            if (sequences[i].newSequence === id) {
                previous = sequences[i];
            }
        }

        return previous;
    }

    async tagSample(ipfsHash, tag, guildId=0) {
        return new Promise(async (resolve, reject) => {
            ipfsHash = ipfsHashToBytes32(ipfsHash);
            tag = convertAsciiToContractHex(tag);
            new EthereumTransaction(
                GUILD_SAMPLES,
                'setSampleTag',
                [ipfsHash, tag, guildId])
                .execute()
                .then(() => resolve());
        });
    }

    async newSampleWithMetadata(ipfsHash, title, youtubeId, tags, styles, country, year, guildId=this.guildId) {
        return new Promise(async (resolve, reject) => {
            let nullBytes32 = web3.utils.padLeft('0x0', 64);
            if (tags === undefined) {
                tags = [];
            }
            if (tags.length < 4) {
                for (let i=tags.length; i < 4; i++) {
                    tags.push(null);
                }
            }

            tags = tags.map(x => x === null ? nullBytes32 : web3.utils.fromAscii(x));
            styles = styles.map(x => x === null  ? nullBytes32 : web3.utils.fromAscii(x));
            country = country === null ? nullBytes32 : web3.utils.fromAscii(country);
            youtubeId = youtubeId === null ? nullBytes32 : web3.utils.fromAscii(youtubeId);

            ipfsHash = ipfsHashToBytes32(ipfsHash);
            new EthereumTransaction(
                GUILD_SAMPLES,
                'newSampleWithMetadata',
                [
                    ipfsHash,
                    title,
                    youtubeId,
                    tags,
                    styles,
                    country,
                    year === null ? 0 : year,
                    0, // ignore discogsId 
                    nullBytes32,
                    guildId])
                .execute()
                .then(() => resolve());
        });
    }

    splitArray(input, spacing) {
        var output = [];
        
        for (var i = 0; i < input.length; i += spacing)
        {
            output.push(input.slice(i, i + spacing));
        }

        return output;
    }
    
    async newEncryptedSamples(samples, guildId=this.guildId, contentKey) {
        return new Promise(async (resolve, reject) => {
            this.splitArray(samples, 16)
                .forEach(s => this.newEncryptedSamples16(s, guildId, contentKey));
        });
    }

    newEncryptedSamples16(samples, guildId, contentKey) {
        return new Promise(async (resolve, reject) => {
            let args = convertSamplesArguments(samples);
            new EthereumTransaction(
                GUILD_SAMPLES,
                'newEncryptedSamples',
                [
                    args.sampleHashes,
                    args.titles,
                    args.videoIds,
                    args.coverArts,
                    args.discogsIds,
                    args.tags,
                    args.styles,
                    args.countries,
                    args.years,
                    guildId,
                    contentKey.convertForEthereum(),
                    contentKey.getPublicKeyAsBytes32()])
                .execute()
                .then(() => resolve());
        });
    }

    async newSamplesWithMetadata(samples, guildId=this.guildId) {
        return new Promise(async (resolve, reject) => {
            this.splitArray(samples, 16)
                .forEach(s => this.newSamplesWithMetadata16(s, guildId));
        });
   }

   async newSamplesWithMetadata16(samples, guildId=this.guildId) {
        return new Promise(async (resolve, reject) => {
            let args = convertSamplesArguments(samples);
            new EthereumTransaction(
                GUILD_SAMPLES,
                'newSamplesWithMetadata',
                [
                    args.sampleHashes,
                    args.titles,
                    args.videoIds,
                    args.coverArts,
                    args.discogsIds,
                    args.tags,
                    args.styles,
                    args.countries,
                    args.years,
                    guildId])
                .execute()
                .then(() => resolve());
        });
    }
}

function convertSamplesArguments(samples) {
    let ipfsHashes = samples.map(sample => ipfsHashToBytes32(sample.ipfsHash));
    let nullBytes32 = web3.utils.padLeft('0x0', 64);
    for (let i=ipfsHashes.length; i < 16; i++) {
        ipfsHashes.push(nullBytes32);
    }
    let coverArts = [];
    let discogIds = [];
    let videoIds = [];
    for (let i=0; i < 16; i++) {
        if (samples[i] === undefined) {
            coverArts.push(nullBytes32);
            discogIds.push(0);
            videoIds.push(nullBytes32);
            continue;
        }
        
        let videoId = samples[i].videoId;
        if (videoId === undefined) {
            videoIds.push(nullBytes32);
        } else {
            videoIds.push(web3.utils.fromAscii(videoId));
        }
        let coverArt = samples[i].coverArt;
        if (coverArt === undefined) {
            coverArts.push(nullBytes32);
        } else {
            coverArts.push(ipfsHashToBytes32(coverArt));
        }
        
        if (samples[i].discogsId === undefined) {
            discogIds.push(0);
        } else {
            discogIds.push(samples[i].discogsId);
        }
    }
    let titles = samples.map(sample => web3.utils.fromAscii(sample.title).slice(0, 66));
    for (let i=titles.length; i < 16; i++) {
        titles.push(nullBytes32);
    }
    let tags = samples.map(s => s.tags.map(tag => web3.utils.fromAscii(tag)));
    for (let i=tags.length; i < 16; i++) {
        tags.push([nullBytes32, nullBytes32, nullBytes32, nullBytes32]);
    }
    let styles = samples.map(
        s =>
            s.styles.map(style => {
                return style === null ?
                    nullBytes32 :
                    web3.utils.fromAscii(style);
            }));
    for (let i=styles.length; i < 16; i++) {
        styles.push([nullBytes32, nullBytes32, nullBytes32, nullBytes32]);
    }
    let countries = samples.map(
        sample =>
            sample.country === null ?
            nullBytes32 :
            web3.utils.fromAscii(sample.country));
    for (let i=countries.length; i < 16; i++) {
        countries.push(nullBytes32);
        
    }
    let years = samples.map(sample => sample.year === null || sample.year === undefined ? 0 : sample.year);
    for (let i=years.length; i < 16; i++) {
        years.push(0);
    }
    
    return {
        sampleHashes: ipfsHashes,
        tags: tags,
        titles: titles,
        styles: styles,
        years: years,
        countries: countries,
        discogsIds: discogIds,
        coverArts: coverArts,
        videoIds: videoIds
    };
}

function convertAsciiToContractHex(ascii) {
    let hex = web3.utils.fromAscii(ascii);
    for (let i=hex.length; i <= 65; i++) {
        hex += '0';
    }
    return hex;
}

function ipfsHashToBytes32(ipfs_hash) {
    var h = bs58.decode(ipfs_hash).toString('hex').replace(/^1220/, '');
    if (h.length != 64) {
        return null;
    }
    return '0x' + h;
}

function bytes32ToIPFSHash(hash_hex) {
    //console.log('bytes32ToIPFSHash starts with hash_buffer', hash_hex.replace(/^0x/, ''));
    var buf = new Buffer(hash_hex.replace(/^0x/, '1220'), 'hex')
    return bs58.encode(buf)
}

function trimEmpty(str) {
    let trimmed = "";
    for (let i in str) {
        if (str.charCodeAt(i) == 0) {
            continue;
        }
        trimmed += str.charAt(i);
    }
    return trimmed;
}

function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

const ethereum = new Ethereum();
console.log('initialized ethereum');
export default ethereum;
